import React from "react";

import styles from "./styles.module.scss";

export const AvatarInitials = ({
  name,
  lastName,
  className = "",
  size = 53,
  fontSize = 23,
}) => {
  const getInitials = () => {
    const firstInitial = name ? name.charAt(0).toUpperCase() : "";
    const secondInitial = lastName
      ? lastName.charAt(0).toUpperCase()
      : name && name.length > 1
        ? name.charAt(1).toUpperCase()
        : "";
    return firstInitial + secondInitial;
  };

  const initials = getInitials();

  return (
    <div
      className={`${className} ${styles.avatarInitials}`}
      style={{width: `${size}rem`, height: `${size}rem`}}
    >
      <svg>
        <circle
          cx={"50%"}
          cy={"50%"}
          r={"50%"}
        />

        <text
          x={"50%"}
          y={"50%"}
          textAnchor={"middle"}
          dominantBaseline={"central"}
          style={{fontSize: `${fontSize}rem`}}
        >
          {initials}
        </text>
      </svg>
    </div>
  );
};
